import React, { useEffect, useState } from 'react';
import { getDrmBasicInfo } from "@/api/baseData";
import { useLoadingStore } from "@/stores/loading";
import ConfirmModal from "@/components/ConfirmModal";
import {
  IS_AGREE, 
  IS_USE, 
  CUSTOMER_STATUS,
  PAYMENT_METHOD,
  CREDIT_STATUS,
  USE_METHOD,
  USE_PURPOSE,
  USE_PURPOSE2,
  SYSTEM_STRUCTURE,
  SET_BILLING_POST_ADDR,
  BUSINESS_ENTITY_TYPE,
  BILLING_POST_TYPE,
  MESSAGE_NO_E39,
} from "@/config";
import { useUserStore } from '@/stores/user';
import { useNavigate } from 'react-router-dom';

interface Detail {
  id?: number,
  customer_type_id?: number,
  customer_payment_type_id?: number,
  customer_payment_type_name?: string,
  name?: string,
  approval_status?: string,
  payment_method?: number,
  payment_method_register_status?: string,
  company_credit_status?: string,
  use_purpose?: string,
  use_purpose_detail?: string,
  system_structure?: string,
  is_secondary_use?: number,
  end_using_date?: string,
  secondary_use_method?: string,
  billing_post_type?: string,
  set_billing_post_address?: string,
  billing_post_group_name?: string,
  billing_post_department_name?: string,
  billing_post_last_name?: string,
  billing_post_first_name?: string,
  billing_post_phone_number?: string,
  billing_post_zipcode?: string,
  billing_post_pref?: string,
  billing_post_city?: string,
  billing_post_house_number?: string,
  billing_post_building_name?: string,
  business_entity_type?: number,
  corporate_number?: string,
  company_representative_name?: string,
  company_url?: string,
  apply_using_date?: string,
  start_using_month?: string,
  is_terms_use_agree?: string,
  is_billing_outsourcing?: string,
}

export default function BasicInfoDetail() {
  const navigate = useNavigate();
  const [customerStatus, setCustomerStatus] = useState<string | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<string | null>(null);
  const [creditStatus, setCreditStatus] = useState<string | null>(null);
  const [useMethod, setUseMethod] = useState<string | null>(null);
  const [usePurpose, setUsePurpose] = useState<string | null>(null);
  const [systemStructure, setSystemStructure] = useState<string | null>(null);
  const [businessType, setBusinessType] = useState<string | null>(null);
  const [billingType, setBillingType] = useState<string | null>(null);
  const [billingPostAddr, setBillingPostAddr] = useState<string | null>(null);
  const [isAgree, setIsAgree] = useState<string | null>(null);
  const [isUse, setIsUse] = useState<string | null>(null);
  const [isBilling, setIsBilling] = useState<string | null>(null);
  const setLoading = useLoadingStore(state => state.setLoading);
  const user = useUserStore(state => state.user);
  const [details, setDetails] = useState<Detail[]>([]);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [applyUsingDate, setApplyUsingDate] = useState<string | null>(null);
  const [startUsingMonth, setStartUsingMonth] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true)
    const response = getDrmBasicInfo();
    response.then(result => {
      setDetails(result.data.details);

      // 決済方法
      if (result.data.details[0]['approval_status'] != null) {
        const approval_status = CUSTOMER_STATUS.find((output, index) => {
          return output.value == result.data.details[0]['approval_status'];
        });
        setCustomerStatus(approval_status?.label || '');
      } else {
        setCustomerStatus('');
      }
      // 決済手段
      if (result.data.details[0]['payment_method'] != null) {
        const payment_method = PAYMENT_METHOD.find((output, index) => {
          return output.value == result.data.details[0]['payment_method'];
        });
        setPaymentMethod(payment_method?.label || '');
      } else {
        setPaymentMethod('');
      }
      // 与信審査
      if (result.data.details[0]['company_credit_status']) {
        const credit_status = CREDIT_STATUS.find((output, index) => {
          return output.value == result.data.details[0]['company_credit_status'];
        });
        setCreditStatus(credit_status?.label || '');
      } else {
        setCreditStatus('');
      }
      // 利用目的
      setUsePurpose('');
      if (result.data.details[0]['customer_type_id'] === 1) {
        const use_purpose = USE_PURPOSE.find((output, index) => {
          return output.value == result.data.details[0]['use_purpose'];
        });
        setUsePurpose(use_purpose?.label || '');
      }else if (result.data.details[0]['customer_type_id'] != null) {
        const use_purpose = USE_PURPOSE2.find((output, index) => {
          return output.value == result.data.details[0]['use_purpose'];
        });
        setUsePurpose(use_purpose?.label || '');
      } else {
        setUsePurpose('');
      }
      // システム体系
      setSystemStructure('');
      if (result.data.details[0]['customer_type_id'] === 2 && result.data.details[0]['use_purpose'] == '5') {
        const system_struture = SYSTEM_STRUCTURE.find((output, index) => {
          return output.value == result.data.details[0]['system_structure'];
        });
        setSystemStructure(system_struture?.label || '');
        console.log(result.data.details[0]['system_structure']);
      } else {
        setSystemStructure('');
      }
      
      // DRM-PFの二次利用
      if (result.data.details[0]['is_secondary_use'] === null) {
        result.data.details[0]['is_secondary_use'] = 0;
      }
      setIsUse(IS_USE[result.data.details[0]['is_secondary_use']]);
      // 二次利用方法
      if (result.data.details[0]['secondary_use_method'] != null) {
        const use_method = USE_METHOD.find((output, index) => {
          return output.value == result.data.details[0]['secondary_use_method'];
        });
        setUseMethod(use_method?.label || '');
      } else {
        setUseMethod('');
      }

      // 事業体区分
      if (result.data.details[0]['business_entity_type'] != null) {
        const entry_type = BUSINESS_ENTITY_TYPE.find((output, index) => {
          return output.value == result.data.details[0]['business_entity_type'];
        });
        setBusinessType(entry_type?.label || '');
      } else {
        setBusinessType('');
      }
      // 請求先
      if (result.data.details[0]['billing_post_type'] != null) { 
        const billing_type = BILLING_POST_TYPE.find((output, index) => {
          return output.value == result.data.details[0]['billing_post_type'];
        });
        setBillingType(billing_type?.label || '');
      } else {
        setBillingType('');
      }
      // 請求先情報
      if (result.data.details[0]['set_billing_post_address'] != null) {
        const set_billing_post_address = SET_BILLING_POST_ADDR.find((output, index) => {
          return output.value == result.data.details[0]['set_billing_post_address'];
        });
        setBillingPostAddr(set_billing_post_address?.label || '');
      } else {
        setBillingPostAddr('');
      }
      // 同意
      if (result.data.details[0]['is_terms_use_agree'] != null) {
        setIsAgree(IS_AGREE[result.data.details[0]['is_terms_use_agree']]);
      } else {
        setIsAgree('');
      }

      if (result.data.details[0]['is_secondary_use'] != null) {
        setIsUse(IS_USE[result.data.details[0]['is_secondary_use']]);
      } else {
        setIsUse('');
      }
      if (result.data.details[0]['is_billing_outsourcing'] != null) {
        setIsBilling(IS_AGREE[result.data.details[0]['is_billing_outsourcing']]);
      } else {
        setIsBilling('');
      }

      if (result.data.details[0]['apply_using_date'] != null) {
        const apply_using_date = new Date(result.data.details[0]['apply_using_date']);
        setApplyUsingDate(`${apply_using_date.getFullYear()}年${apply_using_date.getMonth() + 1}月${apply_using_date.getDate()}日`);
      } else {
        setApplyUsingDate('');
      }
      if (result.data.details[0]['start_using_month'] != null) {
        const start_using_month = new Date(result.data.details[0]['start_using_month']);
        setStartUsingMonth(`${start_using_month.getFullYear()}年${start_using_month.getMonth() + 1}月`);
      } else {
        setStartUsingMonth('');
      }
    }).catch(error => {
      console.log("error");
      setErrorMessage(MESSAGE_NO_E39);
    }).finally(() => {
      setLoading(false);
    });
  }, [])

  useEffect(() => {
    if (errorMessage) {
      setIsShowErrorModal(true);
    }
  }, [errorMessage])

  return (
    <div>
      <div className="info-tbl_wrap uk-margin-small-top">
        <table className="info-tbl uk-width-1-1">
        {details.map((item, index) => {
          return (
            <tbody key={item.id}>
              <tr>
                <th className="label">課金区分</th>
                <td className="content">{item.customer_payment_type_name}</td>
              </tr>
              <tr>
                <th className="label">承認状況</th>
                <td className="content">{customerStatus}</td>
              </tr>
              {item.customer_payment_type_id !== 1 &&
              <>
              <tr>
                <th className="label">決済方法</th>
                <td className="content">{paymentMethod}</td>
              </tr>
                {item.payment_method === 1 &&
                  <>
                  <tr>
                    <th className="label">クレジットカード登録状況</th>
                    { item.payment_method_register_status == '5' ? (<td className="content">登録完了</td>) : (<td className="content">未登録</td>)}
                  </tr>
                  </>
                }
                {(item.payment_method === 15 || item.payment_method === 16)  &&
                  <>
                  <tr>
                    <th className="label">与信審査</th>
                    <td className="content">{creditStatus}</td>
                  </tr>
                  </>
                }
              </>
              }
              <tr>
                <th className="label">利用目的</th>
                <td className="content">{usePurpose}</td>
              </tr>
              {systemStructure &&
              <tr>
                <th className="label">システム体系</th>
                <td className="content">{systemStructure}</td>
              </tr>
              }
              <tr>
                <th className="label">利用目的詳細</th>
                <td className="content">{item.use_purpose_detail}</td>
              </tr>
              <tr>
                <th className="label">利用終了日</th>
                <td className="content">{item.end_using_date}</td>
              </tr>
              <tr>
                <th className="label">DRM-PFの二次利用</th>
                <td className="content">{isUse}</td>
              </tr>
              {item.is_secondary_use === 1 &&
              <tr>
                <th className="label">二次利用方法</th>
                <td className="content">{useMethod}</td>
              </tr>
              }
              <tr>
                <th className="label">利用申請日</th>
                <td className="content">{applyUsingDate}</td>
              </tr>
              <tr>
                <th className="label">利用開始月</th>
                <td className="content">{startUsingMonth}</td>
              </tr>
              {item.customer_payment_type_id !== 1 &&
              <>
              <tr>
                <th className="label">請求先</th>
                <td className="content">{billingType}</td>
              </tr>
              {item.billing_post_type !== '1' &&
              <>
              <tr>
                <th className="label">請求先情報</th>
                <td className="content">{billingPostAddr}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 法人・団体名</th>
                <td className="content">{item.billing_post_group_name}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 部署名・所属</th>
                <td className="content">{item.billing_post_department_name}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 姓</th>
                <td className="content">{item.billing_post_last_name}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 名</th>
                <td className="content">{item.billing_post_first_name}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 電話番号</th>
                <td className="content">{item.billing_post_phone_number}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 郵便番号</th>
                <td className="content">{item.billing_post_zipcode}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 都道府県</th>
                <td className="content">{item.billing_post_pref}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 市区町村</th>
                <td className="content">{item.billing_post_city}</td>
              </tr>
              <tr>
                <th className="label">請求先 - 町名番地</th>
                <td className="content">{item.billing_post_house_number}</td>
              </tr>
              <tr>
                <th className="label">建物名・部屋番号</th>
                <td className="content">{item.billing_post_building_name}</td>
              </tr>
                </>
              }
              <tr>
                <th className="label">事業体区分</th>
                <td className="content">{businessType}</td>
              </tr>
              {item.business_entity_type === 1 &&
              <>
              <tr>
                <th className="label">法人番号</th>
                <td className="content">{item.corporate_number}</td>
              </tr>
              <tr>
                <th className="label">会社代表名</th>
                <td className="content">{item.company_representative_name}</td>
              </tr>
              <tr>
                <th className="label">会社URL</th>
                <td className="content">{item.company_url}</td>
              </tr>
              </>
              }
              </>
              }
              <tr>
                <th className="label">利用規約及び別紙</th>
                <td className="content">{isAgree}</td>
              </tr>
              {item.customer_payment_type_id !== 1 &&
              <tr>
                <th className="label">請求代行業務の同意</th>
                <td className="content">{isBilling}</td>
              </tr>
              }
          </tbody>
          );
        })}
        </table>
        
      </div>

      {errorMessage &&
          <ConfirmModal
              text={errorMessage}
              confirmButtonText="OK"
              isShow={isShowErrorModal}
              onConfirm={() => {
                setIsShowErrorModal(false);
                setErrorMessage(null);
                navigate("/basic_info");
              }}
          />
        }
    </div>
  );
}
